/**
 * Typography Variants Configuration
 *
 * Custom typography variants for the application.
 * These extend Material UI's default typography system.
 */

import { TypographyVariantsOptions } from '@mui/material/styles';

export const typographyVariants: TypographyVariantsOptions = {
	// Font family
	fontFamily: ['Sen', 'Arial', 'sans-serif'].join(','),
	// Headings
	h1: {
		fontWeight: 700,
		fontSize: '3rem',
		lineHeight: 1.2,
	},
	h2: {
		fontWeight: 700,
		fontSize: '28px',
		lineHeight: '33.6px',
	},
	h3: {
		fontWeight: 600,
		fontSize: '18px',
		lineHeight: '21.6px',
	},
	h4: {
		fontWeight: 600,
		fontSize: '16px',
		lineHeight: '19.5px',
	},
	h5: {
		fontWeight: 500,
		fontSize: '1.5rem',
		lineHeight: 1.5,
	},
	h6: {
		fontWeight: 600,
		fontSize: '1.25rem',
		lineHeight: 1.6,
	},

	// Subtitles
	subtitle1: {
		fontWeight: 500,
		fontSize: '1rem',
		lineHeight: 1.75,
	},
	subtitle2: {
		fontWeight: 500,
		fontSize: '0.875rem',
		lineHeight: 1.57,
	},

	// Body text
	body1: {
		fontWeight: 400,
		fontSize: '1rem',
		lineHeight: 1.5,
	},
	body2: {
		fontWeight: 400,
		fontSize: '0.875rem',
		lineHeight: 1.5,
	},

	// Button text
	button: {
		fontWeight: 500,
		fontSize: '0.875rem',
		lineHeight: 1.75,
		textTransform: 'none',
	},

	// Caption and overline
	caption: {
		fontWeight: 600,
		fontSize: '0.75rem',
		lineHeight: 1.66,
		letterSpacing: '0.5px',
		textTransform: 'uppercase',
	},
	overline: {
		fontWeight: 600,
		fontSize: '0.75rem',
		lineHeight: 2.66,
		letterSpacing: '1px',
		textTransform: 'uppercase',
	},
};
